import * as angular from 'angular';
import { MixableBaseController } from '~/common/component';
import { DesignerErrorType } from '../../../../types/viz-designer.types';

export class DesignerErrorController {
  chartType: string;

  handleChartType(chartType: string | undefined): string {
    if (chartType && chartType.toLowerCase().includes('table')) {
      return 'table';
    }

    return 'chart';
  }
}

export const DesignerErrorComponent: angular.IComponentOptions = {
  bindings: {
    error: '@',
    onAction: '&',
    objectContext: '<',
    chartType: '<?',
    queryToken: '<',
  },
  controller: DesignerErrorController,
  controllerAs: 'ctrl',
  template: `
  <div class="chart-error-container">
    <div class="error error--broken-viz" ng-if="ctrl.objectContext === 'exploration'">
      <div><i class="icon-broken-viz"></i></div>
      <h4>Sorry, the dataset powering this exploration has failed.</h4>
    </div>
    <div class="error error--run-failed" ng-if="ctrl.objectContext === 'visualization' && ctrl.error === '${DesignerErrorType.RunFailed}'">
      <div><i class="icon-broken-viz"></i></div>
      <h4>Sorry, this {{ctrl.handleChartType(ctrl.chartType)}} can't be displayed &mdash;<br/>there's an error in the source data</h4>
      <a ui-sref="application.reports.edit.queries.edit({queryToken: ctrl.queryToken})">
        See what's wrong
      </a>
    </div>
    <div class="error error--broken-big-number" ng-if="ctrl.objectContext === 'visualization' && ctrl.error === '${DesignerErrorType.OversizeBigNumber}'">
      <div><i class="icon-broken-bignumber"></i></div>
      <h4>Sorry, this Big Number can't be displayed - the data is too large.</h4>
      <p>Try creating a Big Value instead.</p>
      <button class="btn btn-primary" ng-click="ctrl.onAction()">Create Big Value</button>
    </div>
  </div>
  `,
};
